import React from "react";

import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { Card } from "@/uiKit/atoms/Card.tsx";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { CardFooter } from "@/uiKit/atoms/CardFooter.tsx";
import { CardHeader } from "@/uiKit/atoms/CardHeader.tsx";
import { NurseInclusionHistoryTable } from "@/uiKit/molecules/InclusionCenter/NurseInclusion/NurseInclusionHistoryTable.tsx";

export type NurseInclusionHistoryCardProps = {
  onClose?: () => void;
  className?: string;
};

export const NurseInclusionHistoryCard: React.FC<NurseInclusionHistoryCardProps> = ({ className, onClose }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <Card className={cx(styles.container, className)}>
      <CardHeader
        id="nurse-inclusion-history-header"
        title={t("nurseInclusion.history.title")}
        variant="contained"
        onExit={onClose}
      />
      <CardContent>
        <NurseInclusionHistoryTable />
      </CardContent>
      <CardFooter />
    </Card>
  );
};

const makeStyles = () => ({
  container: css({}),
});
